module.exports = __webpack_public_path__ + "static/media/contacto.6cf38ad3.jpg";